import axios from "axios";
import Config from "src/config";

const v1_actionMessengerClonarBiblioteca = (clienteId, data) => {
    return axios({
        method: "post",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v1/${clienteId}/canais/messenger/templates/biblioteca/clonar`,
        data
    });
};

export default v1_actionMessengerClonarBiblioteca;
